import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BASE}/api`;

export const JWT_KEY = "nailViet.adminJWT";
export const LEGACY_TOKEN_KEY = "nailEvent.adminToken";

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

// Auto-attach Bearer JWT (if present) AND keep legacy X-Admin-Token working.
api.interceptors.request.use((config) => {
  try {
    const jwt = typeof window !== "undefined" ? localStorage.getItem(JWT_KEY) : null;
    if (jwt && !config.headers?.Authorization) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${jwt}`;
    }
    // If a route already sets X-Admin-Token explicitly, do not overwrite.
    const legacy = typeof window !== "undefined" ? sessionStorage.getItem(LEGACY_TOKEN_KEY) : null;
    if (legacy && !config.headers?.["X-Admin-Token"]) {
      config.headers = config.headers || {};
      config.headers["X-Admin-Token"] = legacy;
    }
  } catch (_err) { /* ignore */ }
  return config;
});

// Auto-redirect to /admin/login on 401 for /api/admin/* calls (preserves UX).
api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (typeof window !== "undefined") {
      const status = error?.response?.status;
      const url = error?.config?.url || "";
      const isAdminCall = url.startsWith("/admin") || url.includes("/api/admin");
      const isOnLogin = window.location.pathname.startsWith("/admin/login");
      if (status === 401 && isAdminCall && !isOnLogin) {
        try {
          localStorage.removeItem(JWT_KEY);
          sessionStorage.removeItem(LEGACY_TOKEN_KEY);
        } catch (_err) { /* ignore */ }
      }
    }
    return Promise.reject(error);
  }
);

export function csvDownloadUrl(slug, adminToken) {
  const jwt = (typeof window !== "undefined" && localStorage.getItem(JWT_KEY)) || "";
  const token = jwt || adminToken || "";
  return `${API_BASE}/admin/nail-events/${encodeURIComponent(slug)}/export.csv?token=${encodeURIComponent(token)}`;
}

// Phase 8.17 — VIP-only roster download for hosts.
export function vipRosterDownloadUrl(slug, adminToken) {
  const jwt = (typeof window !== "undefined" && localStorage.getItem(JWT_KEY)) || "";
  const token = jwt || adminToken || "";
  return `${API_BASE}/admin/nail-events/${encodeURIComponent(slug)}/vip-roster.csv?token=${encodeURIComponent(token)}`;
}

const VISIT_KEY = "nailEvent.firstVisit";
const TRACK_KEY = "nailEvent.track";

export function captureCampaign(searchParams) {
  const get = (k) => searchParams.get(k) || undefined;
  const data = {
    source: get("source"),
    utm_source: get("utm_source"),
    utm_medium: get("utm_medium"),
    utm_campaign: get("utm_campaign"),
    utm_content: get("utm_content"),
    utm_term: get("utm_term"),
    landing_page: typeof window !== "undefined" ? window.location.pathname + window.location.search : undefined,
    referrer: typeof document !== "undefined" ? (document.referrer || undefined) : undefined,
  };
  if (typeof window === "undefined") return data;
  let firstVisit = localStorage.getItem(VISIT_KEY);
  if (!firstVisit) {
    firstVisit = new Date().toISOString();
    localStorage.setItem(VISIT_KEY, firstVisit);
  }
  data.first_visit_at = firstVisit;
  const existing = JSON.parse(localStorage.getItem(TRACK_KEY) || "null") || {};
  const merged = { ...existing };
  for (const k of Object.keys(data)) {
    if (data[k] && !merged[k]) merged[k] = data[k];
  }
  localStorage.setItem(TRACK_KEY, JSON.stringify(merged));
  return merged;
}

export function getCampaignTrack() {
  try {
    return JSON.parse(localStorage.getItem(TRACK_KEY) || "{}");
  } catch { return {}; }
}
